/* BUNA product card: "+" quick add.
   - One option: adds to cart right here.
   - Several options (sizes): opens a size list on the card; tap a size to add it.
   After adding: opens the theme's cart drawer / notification if there is one
   and updates the header count. */
(function () {
  if (window.__bunaCardQA) return;
  window.__bunaCardQA = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var openPanel = null;

  // Find the "+" that was tapped. Fallback: if a hover animation put the
  // card's title link on top of it, match the tap position to the button.
  function findAdd(e) {
    var direct = e.target.closest && e.target.closest('[data-buna-add]');
    if (direct) return direct;
    if (typeof e.clientX !== 'number') return null;
    var card = e.target.closest && e.target.closest('.product-card-wrapper');
    if (!card) return null;
    var btn = card.querySelector('[data-buna-add]');
    if (!btn) return null;
    var r = btn.getBoundingClientRect();
    return (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) ? btn : null;
  }

  function themeCart() {
    var el = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    return el && typeof el.renderContents === 'function' && typeof el.getSectionsToRender === 'function' ? el : null;
  }

  function closePanel() {
    if (!openPanel) return;
    openPanel.hidden = true;
    var card = openPanel.closest('.product-card-wrapper');
    if (card) card.classList.remove('has-sizes-open');
    openPanel = null;
  }
  function togglePanel(btn) {
    var card = btn.closest('.product-card-wrapper');
    var panel = card && card.querySelector('[data-buna-sizes]');
    if (!panel) return false;
    if (openPanel === panel) { closePanel(); return true; }
    closePanel();
    panel.hidden = false;
    card.classList.add('has-sizes-open');
    openPanel = panel;
    var first = panel.querySelector('[data-buna-size]:not([disabled])');
    if (first) first.focus({ preventScroll: true });
    return true;
  }

  function add(variantId, feedbackBtn) {
    if (!variantId || feedbackBtn.classList.contains('is-loading')) return;
    var cart = themeCart();
    var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(feedbackBtn);
    }

    feedbackBtn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || 'Could not add to cart'); return data; }); })
      .then(function (data) {
        feedbackBtn.classList.remove('is-loading');
        feedbackBtn.classList.add('is-added');
        setTimeout(function () { feedbackBtn.classList.remove('is-added'); }, 1800);
        closePanel();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        if (cart) {
          var item = data.items ? data.items[0] : data;
          if (data.sections) item.sections = data.sections;
          try { cart.classList.remove('is-empty'); cart.renderContents(item); } catch (err) { /* count still updates */ }
        }
      })
      .catch(function (err) {
        feedbackBtn.classList.remove('is-loading');
        alert(err.message);
      });
  }

  window.addEventListener('click', function (e) {
    // A size inside the open list
    var size = e.target.closest && e.target.closest('[data-buna-size]');
    if (size) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (size.disabled) return;
      var card = size.closest('.product-card-wrapper');
      var plus = card && card.querySelector('[data-buna-add]');
      size.classList.add('is-picked');
      setTimeout(function () { size.classList.remove('is-picked'); }, 600);
      add(size.getAttribute('data-buna-size'), plus || size);
      return;
    }
    // Close button / clicks inside the list (never open the product)
    if (e.target.closest && e.target.closest('[data-buna-sizes]')) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      if (e.target.closest('[data-buna-sizes-close]')) closePanel();
      return;
    }
    // The "+" button
    var btn = findAdd(e);
    if (btn) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (variantId) { add(variantId, btn); return; }
      if (!togglePanel(btn)) window.location.href = btn.getAttribute('data-url');   // too many options: product page
      return;
    }
    // Anywhere else closes an open list
    closePanel();
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
})();
